<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Permitted Products</div>
      </div>
      <v-spacer></v-spacer>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
    </v-card-title>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="product" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.product }}</td>
        <td class="text-xs-left">{{ props.item.productDesc }}</td>
        <td class="text-xs-right">
          <table-action :rowData="props" remove @remove="doPromptRemove(props.item)" :loading="loading"></table-action>
        </td>
      </template>
    </v-data-table>
    <v-card-text>
      <v-btn slot="activator" color="primary" dark class="mb-2" @click="doNew()">
        Permit Product
        <v-icon right>mdi-cube-outline</v-icon>
      </v-btn>
    </v-card-text>
    <v-dialog v-model="addProductDialog" max-width="800px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Permit Product for Campaign</span>
        </v-card-title>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 md4>
                <v-autocomplete :label="labels.productType" v-model="appID" :items="appIDList" item-text="label" item-value="value" :error-messages="errors.collect('productType')" data-vv-name="productType" :data-vv-as="labels.productType" v-validate="'required'" @input="getProducts"></v-autocomplete>
              </v-flex>
              <v-flex xs12 md8>
                <v-autocomplete :label="labels.product" v-model="productCampaignForm.product" :items="productList" item-text="label" item-value="value" :error-messages="errors.collect('product')" data-vv-name="product" :data-vv-as="labels.product" v-validate="'required'" :loading="productLoading"></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Permitted Product?
      <div class="title">{{deleteProductCampaign}}</div>
    </confirm>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      headers: [
        { text: 'Product Code', align: 'left', value: 'product', sortable: false },
        { text: 'Product Description', align: 'left', value: 'productDesc', sortable: false },
        TableConst.tableActionHeader
      ],
      labels: {
        productType: 'Product Type*',
        product: 'Product*'
      },
      productCampaignForm: {
        campaign: undefined,
        product: undefined
      },
      totalItems: 0,
      loading: false,
      items: [],
      appID: undefined,
      addProductDialog: false,
      productLoading: false,
      productList: [],
      promptRemove: false,
      selectedProductCampaign: undefined,
      deleteProductCampaign: ''
    }
  },
  computed: {
    appIDList() {
      return this.$store.state.promotionManagement.campaign.appIDList
    }
  },
  methods: {
    async doInit() {
      this.productCampaignForm.campaign = this.campaign
      await this.queryProductCampaign()
    },
    async queryProductCampaign() {
      const apiURI = this.$store.state.promotionManagement.campaign.menu.campaignProducts
      if (apiURI) {
        try {
          this.loading = true
          const expand = {
            campaign: this.campaign
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((productCampaign) => {
                const convertProductCampaign = {
                  campaign: productCampaign.campaign,
                  campaignDesc: productCampaign.campaignDesc,
                  product: productCampaign.product,
                  productDesc: productCampaign.productDesc
                }
                this.items.push(convertProductCampaign)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          throw err
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getProducts() {
      const apiURI = this.$store.state.promotionManagement.campaign.menu.productList
      if (apiURI) {
        try {
          this.productLoading = true
          const expand = {
            appId: this.appID
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            let result = []
            result = data
            // Remove those that already permitted
            result = result.filter(product => {
              for (let permittedProduct of this.items) {
                if (permittedProduct.product === product.value) {
                  return false
                }
              }
              return true
            })
            this.productList = result
          }
          this.productLoading = false
        } catch (err) {
          throw err
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doSave() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.doCreate()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doNew() {
      this.resetMessages()
      this.productCampaignForm.product = undefined
      this.addProductDialog = true
    },
    async doCreate() {
      const apiURI = this.$store.state.promotionManagement.campaign.menu.campaignProductCreate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.productCampaignForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            this.doClose()
            // Fetch list again
            this.queryProductCampaign()
          }
          this.submitting = false
        } catch (err) {
          console.log(err)
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doClose() {
      this.resetMessages()
      this.appID = undefined
      this.productCampaignForm.product = undefined
      this.addProductDialog = false
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedProductCampaign = data
        this.deleteProductCampaign = data.product + ' - ' + data.productDesc
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.promotionManagement.campaign.menu.campaignProductDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          campaign: this.campaign,
          product: this.selectedProductCampaign.product
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.queryProductCampaign()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    }
  },
  props: {
    campaign: {
      type: String,
      default: ''
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">
</style>
